export default function PageHeader({ title, subtitle, icon: Icon, actions, breadcrumb }) {
  return (
    <div className="mb-6 fade-up">
      {breadcrumb && (
        <div className="text-xs text-slate-400 mb-2 flex items-center gap-1.5">
          {breadcrumb.map((b, i) => (
            <span key={i} className="flex items-center gap-1.5">
              {i > 0 && <span>/</span>}
              <span className={i === breadcrumb.length - 1 ? "text-slate-600 dark:text-foreground font-medium" : ""}>{b}</span>
            </span>
          ))}
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="h-11 w-11 rounded-lg bg-blue-50 dark:bg-blue-500/10 flex items-center justify-center shrink-0">
              <Icon className="h-6 w-6 text-blue-600" strokeWidth={2} />
            </div>
          )}
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-foreground">{title}</h1>
            {subtitle && <p className="text-sm text-slate-500 dark:text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
